<template>
    <div class="edit-page">
        <Header></Header>

        <div class="edit-container">
            <div class="edit-inner">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="edit-form" @submit.native.prevent>
                    <el-form-item label="标题" prop="title">
                        <el-input v-model="ruleForm.title" placeholder="请输入文章标题"></el-input>
                    </el-form-item>

                    <el-form-item label="摘要" prop="description">
                        <el-input type="textarea" v-model="ruleForm.description" placeholder="请输入文章摘要" :rows="3"></el-input>
                    </el-form-item>

                    <el-form-item label="内容" prop="content">
                        <mavon-editor v-model="ruleForm.content" style="min-height: 500px;"></mavon-editor>
                    </el-form-item>

                    <el-form-item class="form-actions">
                        <el-button type="primary" @click="submitForm('ruleForm')" class="submit-btn">
                            发布文章
                        </el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "../components/Header";
    export default {
        name: "BlogEdit.vue",
        components: {Header},
        data() {
            return {
                ruleForm: {
                    id: '',
                    title: '',
                    description: '',
                    content: ''
                },
                rules: {
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' },
                        { min: 3, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur' }
                    ],
                    description: [
                        { required: true, message: '请输入摘要', trigger: 'blur' }
                    ],
                    content: [
                        { required: true, message: '请输入内容', trigger: 'blur' }
                    ]
                }
            };
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const _this = this
                        this.$axios.post('/blog/edit', this.ruleForm, {
                            headers: {
                                "Authorization": localStorage.getItem("token")
                            }
                        }).then(res => {
                            console.log(res)
                            _this.$alert('操作成功', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    _this.$router.push("/blogs")
                                }
                            });
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        },
        created() {
            const blogId = this.$route.params.blogId
            console.log(blogId)
            const _this = this
            if(blogId) {
                this.$axios.get('/blog/' + blogId).then(res => {
                    const blog = res.data.data
                    _this.ruleForm.id = blog.id
                    _this.ruleForm.title = blog.title
                    _this.ruleForm.description = blog.description
                    _this.ruleForm.content = blog.content
                })
            }
        }
    }
</script>

<style scoped>
    .edit-page {
        min-height: 100vh;
        background: #f5f5fb;
    }

    .edit-container {
        max-width: 960px;
        margin: 0 auto;
        padding: 32px 20px 60px;
    }

    .edit-inner {
        background: #fff;
        border-radius: 12px;
        padding: 32px 36px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    }

    .edit-form >>> .el-input__inner {
        border-radius: 6px;
    }

    .edit-form >>> .el-textarea__inner {
        border-radius: 6px;
    }

    .form-actions {
        margin-top: 24px;
        margin-bottom: 0;
    }

    .submit-btn {
        padding: 10px 32px;
        border-radius: 6px;
        background: linear-gradient(135deg, #58a8e0 0%, #58a8e0 100%);
        border: none;
    }

    .submit-btn:hover {
        opacity: 0.9;
    }
</style>
